import { DatePipe } from '@angular/common';

export const YEAR = 'yyyy';
export const MONTH_YEAR = 'MMM yyyy';
export const DEFAULT_FORMAT = 'dd MMM yyyy';
export const FULL_DATE_FORMAT = 'dd MMM yyyy, H:mm:ss';
const EMPTY_TIME_STRING = 'T00:00:00.00';

export const FormatDate = (
    datePipe: DatePipe,
    value: Date | string | undefined | null,
    format: string = DEFAULT_FORMAT,
    defaultValue: string = '-'
): string => {
    if (value === '' || typeof value === 'undefined' || value === null) {
        return defaultValue;
    }

    try {
        return datePipe.transform(value, format) || defaultValue;
    } catch (err) {
        return value.toString();
    }
};
